const files = require.context('../pages', true, /routes\/index.tsx$/);

const pageRoutes = [];
files.keys().forEach(file => {
  pageRoutes.push(...files(file).routes.filter(v => v.enable));
});
pageRoutes.sort((a, b) => {
  const aOrder = a.order || 0;
  const bOrder = b.order || 0;
  return bOrder - aOrder;
});
export { pageRoutes };